import * as THREE from 'three'; // build/three.js from node_module/three
window.THREE = THREE;
require('three/examples/js/controls/OrbitControls.js');
require('three/examples/js/loaders/ColladaLoader.js');
//require('three/examples/js/libs/stats.min.js');
export default THREE;